// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-color: #4a90e2;
  --secondary-color: #50c878;
  --danger-color: #e74c3c;
  --warning-color: #f39c12;
  --background: #f5f7fa;
  --surface: #ffffff;
  --text-primary: #2c3e50;
  --text-secondary: #7f8c8d;
  --border-color: #dfe6e9;
  --shadow: rgba(0, 0, 0, 0.1);
  --favorite-color: #ffd700;
}

body.dark-mode {
  --background: #1a1a2e;
  --surface: #16213e;
  --text-primary: #eaeaea;
  --text-secondary: #b0b0b0;
  --border-color: #2d3748;
  --shadow: rgba(0, 0, 0, 0.3);
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: var(--background);
  color: var(--text-primary);
  transition: background-color 0.3s, color 0.3s;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* Container */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

/* Auth Pages */
.auth-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, var(--primary-color) 0%, var(--secondary-color) 100%);
}

.auth-card {
  background: var(--surface);
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 10px 40px var(--shadow);
  width: 100%;
  max-width: 400px;
}

.auth-card h1 {
  text-align: center;
  margin-bottom: 30px;
  color: var(--text-primary);
}

.swagger-link {
  display: block;
  text-align: center;
  margin-top: 20px;
  color: var(--primary-color);
  text-decoration: none;
  font-size: 14px;
}

.swagger-link:hover {
  text-decoration: underline;
}

/* Form */
.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  color: var(--text-primary);
  font-weight: 500;
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  padding: 12px;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  font-size: 14px;
  background: var(--surface);
  color: var(--text-primary);
  transition: border-color 0.3s;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: var(--primary-color);
}

.form-group textarea {
  resize: vertical;
  min-height: 80px;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
}

.checkbox-group {
  display: flex;
  align-items: center;
  gap: 8px;
}

.checkbox-group input[type="checkbox"] {
  width: auto;
  cursor: pointer;
}

/* Buttons */
.btn {
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  justify-content: center;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-primary {
  background: var(--primary-color);
  color: white;
}

.btn-primary:hover:not(:disabled) {
  background: #357abd;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px var(--shadow);
}

.btn-secondary {
  background: var(--secondary-color);
  color: white;
}

.btn-secondary:hover:not(:disabled) {
  background: #45b369;
}

.btn-danger {
  background: var(--danger-color);
  color: white;
}

.btn-danger:hover:not(:disabled) {
  background: #c0392b;
}

.btn-outline {
  background: transparent;
  border: 2px solid var(--primary-color);
  color: var(--primary-color);
}

.btn-outline:hover:not(:disabled) {
  background: var(--primary-color);
  color: white;
}

.btn-full {
  width: 100%;
}

.btn-icon {
  background: transparent;
  border: none;
  padding: 8px;
  cursor: pointer;
  color: var(--text-secondary);
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-icon:hover {
  color: var(--text-primary);
}

/* Header */
.header {
  background: var(--surface);
  border-bottom: 1px solid var(--border-color);
  padding: 15px 0;
  box-shadow: 0 2px 4px var(--shadow);
}

.header-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header h1 {
  font-size: 24px;
  color: var(--text-primary);
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 15px;
}

.user-email {
  color: var(--text-secondary);
  font-size: 14px;
}

/* Toolbar */
.toolbar {
  background: var(--surface);
  padding: 20px;
  border-radius: 12px;
  margin-bottom: 20px;
  box-shadow: 0 2px 8px var(--shadow);
}

.toolbar-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  flex-wrap: wrap;
  gap: 15px;
}

.search-box {
  flex: 1 1;
  min-width: 250px;
  position: relative;
}

.search-box input {
  width: 100%;
  padding: 10px 40px 10px 15px;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  background: var(--background);
  color: var(--text-primary);
}

.search-icon {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--text-secondary);
}

.toolbar-bottom {
  display: flex;
  gap: 15px;
  align-items: center;
  flex-wrap: wrap;
}

.filter-group {
  display: flex;
  align-items: center;
  gap: 10px;
}

.filter-group label {
  color: var(--text-secondary);
  font-size: 14px;
}

.filter-group select {
  padding: 8px 12px;
  border: 1px solid var(--border-color);
  border-radius: 6px;
  background: var(--surface);
  color: var(--text-primary);
  font-size: 14px;
  cursor: pointer;
  transition: border-color 0.3s;
}

.filter-group select:focus {
  outline: none;
  border-color: var(--primary-color);
}

.view-toggle {
  display: flex;
  gap: 5px;
  background: var(--background);
  padding: 5px;
  border-radius: 8px;
}

.view-toggle button {
  padding: 8px 12px;
  border: none;
  background: transparent;
  cursor: pointer;
  border-radius: 6px;
  color: var(--text-secondary);
}

.view-toggle button.active {
  background: var(--primary-color);
  color: white;
}

/* Contacts Grid */
.contacts-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
}

/* Contact Card */
.contact-card {
  background: var(--surface);
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px var(--shadow);
  transition: transform 0.2s, box-shadow 0.2s;
  position: relative;
}

.contact-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 16px var(--shadow);
}

.contact-card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 15px;
}

.contact-avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid var(--border-color);
}

.contact-actions {
  display: flex;
  gap: 5px;
}

.favorite-star {
  color: var(--favorite-color);
  font-size: 20px;
}

.contact-info h3 {
  margin-bottom: 8px;
  color: var(--text-primary);
  font-size: 18px;
}

.contact-info p {
  color: var(--text-secondary);
  font-size: 14px;
  margin-bottom: 5px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.contact-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  margin-top: 10px;
  background: var(--primary-color);
  color: white;
}

/* Contact List View */
.contacts-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.contact-list-item {
  background: var(--surface);
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px var(--shadow);
  display: flex;
  align-items: center;
  gap: 20px;
}

.contact-list-item .contact-avatar {
  width: 50px;
  height: 50px;
}

.contact-list-info {
  flex: 1 1;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 15px;
}

.contact-list-actions {
  display: flex;
  gap: 10px;
}

/* Modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.modal-content {
  background: var(--surface);
  border-radius: 12px;
  padding: 30px;
  max-width: 600px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 10px 40px var(--shadow);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.modal-header h2 {
  color: var(--text-primary);
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

/* Photo Upload */
.photo-upload {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  margin-bottom: 20px;
}

.photo-preview {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid var(--border-color);
}

.photo-upload input[type="file"] {
  display: none;
}

/* Loading */
.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  color: var(--text-secondary);
}

/* Empty State */
.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: var(--text-secondary);
}

.empty-state-icon {
  font-size: 64px;
  margin-bottom: 20px;
  opacity: 0.5;
}

/* Responsive */
@media (max-width: 768px) {
  .contacts-grid {
    grid-template-columns: 1fr;
  }

  .toolbar-top,
  .toolbar-bottom {
    flex-direction: column;
    align-items: stretch;
  }

  .search-box {
    width: 100%;
  }

  .contact-list-item {
    flex-direction: column;
    align-items: flex-start;
  }

  .contact-list-info {
    grid-template-columns: 1fr;
  }

  .form-row {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,uBAAuB;EACvB,wBAAwB;EACxB,qBAAqB;EACrB,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,mCAAmC;EACnC,0BAA0B;EAC1B,6CAA6C;AAC/C;;AAEA;EACE;aACW;AACb;;AAEA,cAAc;AACd;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA,eAAe;AACf;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yFAAyF;AAC3F;;AAEA;EACE,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,SAAS;AACT;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;;;EAGE,WAAW;EACX,aAAa;EACb,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;;;EAGE,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,4BAA4B;EAC5B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,WAAW;AACX;EACE,0BAA0B;EAC1B,4CAA4C;EAC5C,eAAe;EACf,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,qCAAqC;EACrC,kBAAkB;EAClB,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;EAClB,0BAA0B;EAC1B,0BAA0B;EAC1B,eAAe;EACf,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,mCAAmC;EACnC,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;EAChC,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAO;EACP,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA,UAAU;AACV;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,aAAa;AACf;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA,eAAe;AACf;EACE;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[":root {\n  --primary-color: #4a90e2;\n  --secondary-color: #50c878;\n  --danger-color: #e74c3c;\n  --warning-color: #f39c12;\n  --background: #f5f7fa;\n  --surface: #ffffff;\n  --text-primary: #2c3e50;\n  --text-secondary: #7f8c8d;\n  --border-color: #dfe6e9;\n  --shadow: rgba(0, 0, 0, 0.1);\n  --favorite-color: #ffd700;\n}\n\nbody.dark-mode {\n  --background: #1a1a2e;\n  --surface: #16213e;\n  --text-primary: #eaeaea;\n  --text-secondary: #b0b0b0;\n  --border-color: #2d3748;\n  --shadow: rgba(0, 0, 0, 0.3);\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: var(--background);\n  color: var(--text-primary);\n  transition: background-color 0.3s, color 0.3s;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n/* Container */\n.container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 20px;\n}\n\n/* Auth Pages */\n.auth-page {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(135deg, var(--primary-color) 0%, var(--secondary-color) 100%);\n}\n\n.auth-card {\n  background: var(--surface);\n  padding: 40px;\n  border-radius: 12px;\n  box-shadow: 0 10px 40px var(--shadow);\n  width: 100%;\n  max-width: 400px;\n}\n\n.auth-card h1 {\n  text-align: center;\n  margin-bottom: 30px;\n  color: var(--text-primary);\n}\n\n.swagger-link {\n  display: block;\n  text-align: center;\n  margin-top: 20px;\n  color: var(--primary-color);\n  text-decoration: none;\n  font-size: 14px;\n}\n\n.swagger-link:hover {\n  text-decoration: underline;\n}\n\n/* Form */\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 8px;\n  color: var(--text-primary);\n  font-weight: 500;\n}\n\n.form-group input,\n.form-group select,\n.form-group textarea {\n  width: 100%;\n  padding: 12px;\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  font-size: 14px;\n  background: var(--surface);\n  color: var(--text-primary);\n  transition: border-color 0.3s;\n}\n\n.form-group input:focus,\n.form-group select:focus,\n.form-group textarea:focus {\n  outline: none;\n  border-color: var(--primary-color);\n}\n\n.form-group textarea {\n  resize: vertical;\n  min-height: 80px;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 15px;\n}\n\n.checkbox-group {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.checkbox-group input[type=\"checkbox\"] {\n  width: auto;\n  cursor: pointer;\n}\n\n/* Buttons */\n.btn {\n  padding: 12px 24px;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  justify-content: center;\n}\n\n.btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.btn-primary {\n  background: var(--primary-color);\n  color: white;\n}\n\n.btn-primary:hover:not(:disabled) {\n  background: #357abd;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px var(--shadow);\n}\n\n.btn-secondary {\n  background: var(--secondary-color);\n  color: white;\n}\n\n.btn-secondary:hover:not(:disabled) {\n  background: #45b369;\n}\n\n.btn-danger {\n  background: var(--danger-color);\n  color: white;\n}\n\n.btn-danger:hover:not(:disabled) {\n  background: #c0392b;\n}\n\n.btn-outline {\n  background: transparent;\n  border: 2px solid var(--primary-color);\n  color: var(--primary-color);\n}\n\n.btn-outline:hover:not(:disabled) {\n  background: var(--primary-color);\n  color: white;\n}\n\n.btn-full {\n  width: 100%;\n}\n\n.btn-icon {\n  background: transparent;\n  border: none;\n  padding: 8px;\n  cursor: pointer;\n  color: var(--text-secondary);\n  font-size: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.btn-icon:hover {\n  color: var(--text-primary);\n}\n\n/* Header */\n.header {\n  background: var(--surface);\n  border-bottom: 1px solid var(--border-color);\n  padding: 15px 0;\n  box-shadow: 0 2px 4px var(--shadow);\n}\n\n.header-content {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.header h1 {\n  font-size: 24px;\n  color: var(--text-primary);\n}\n\n.header-actions {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.user-email {\n  color: var(--text-secondary);\n  font-size: 14px;\n}\n\n/* Toolbar */\n.toolbar {\n  background: var(--surface);\n  padding: 20px;\n  border-radius: 12px;\n  margin-bottom: 20px;\n  box-shadow: 0 2px 8px var(--shadow);\n}\n\n.toolbar-top {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 15px;\n  flex-wrap: wrap;\n  gap: 15px;\n}\n\n.search-box {\n  flex: 1;\n  min-width: 250px;\n  position: relative;\n}\n\n.search-box input {\n  width: 100%;\n  padding: 10px 40px 10px 15px;\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  background: var(--background);\n  color: var(--text-primary);\n}\n\n.search-icon {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--text-secondary);\n}\n\n.toolbar-bottom {\n  display: flex;\n  gap: 15px;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.filter-group {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.filter-group label {\n  color: var(--text-secondary);\n  font-size: 14px;\n}\n\n.filter-group select {\n  padding: 8px 12px;\n  border: 1px solid var(--border-color);\n  border-radius: 6px;\n  background: var(--surface);\n  color: var(--text-primary);\n  font-size: 14px;\n  cursor: pointer;\n  transition: border-color 0.3s;\n}\n\n.filter-group select:focus {\n  outline: none;\n  border-color: var(--primary-color);\n}\n\n.view-toggle {\n  display: flex;\n  gap: 5px;\n  background: var(--background);\n  padding: 5px;\n  border-radius: 8px;\n}\n\n.view-toggle button {\n  padding: 8px 12px;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  border-radius: 6px;\n  color: var(--text-secondary);\n}\n\n.view-toggle button.active {\n  background: var(--primary-color);\n  color: white;\n}\n\n/* Contacts Grid */\n.contacts-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 20px;\n}\n\n/* Contact Card */\n.contact-card {\n  background: var(--surface);\n  border-radius: 12px;\n  padding: 20px;\n  box-shadow: 0 2px 8px var(--shadow);\n  transition: transform 0.2s, box-shadow 0.2s;\n  position: relative;\n}\n\n.contact-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 4px 16px var(--shadow);\n}\n\n.contact-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 15px;\n}\n\n.contact-avatar {\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 3px solid var(--border-color);\n}\n\n.contact-actions {\n  display: flex;\n  gap: 5px;\n}\n\n.favorite-star {\n  color: var(--favorite-color);\n  font-size: 20px;\n}\n\n.contact-info h3 {\n  margin-bottom: 8px;\n  color: var(--text-primary);\n  font-size: 18px;\n}\n\n.contact-info p {\n  color: var(--text-secondary);\n  font-size: 14px;\n  margin-bottom: 5px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.contact-badge {\n  display: inline-block;\n  padding: 4px 12px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 600;\n  margin-top: 10px;\n  background: var(--primary-color);\n  color: white;\n}\n\n/* Contact List View */\n.contacts-list {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.contact-list-item {\n  background: var(--surface);\n  border-radius: 12px;\n  padding: 20px;\n  box-shadow: 0 2px 8px var(--shadow);\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.contact-list-item .contact-avatar {\n  width: 50px;\n  height: 50px;\n}\n\n.contact-list-info {\n  flex: 1;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 15px;\n}\n\n.contact-list-actions {\n  display: flex;\n  gap: 10px;\n}\n\n/* Modal */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n.modal-content {\n  background: var(--surface);\n  border-radius: 12px;\n  padding: 30px;\n  max-width: 600px;\n  width: 100%;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 10px 40px var(--shadow);\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.modal-header h2 {\n  color: var(--text-primary);\n}\n\n.modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 20px;\n}\n\n/* Photo Upload */\n.photo-upload {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 15px;\n  margin-bottom: 20px;\n}\n\n.photo-preview {\n  width: 120px;\n  height: 120px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 3px solid var(--border-color);\n}\n\n.photo-upload input[type=\"file\"] {\n  display: none;\n}\n\n/* Loading */\n.loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 200px;\n  color: var(--text-secondary);\n}\n\n/* Empty State */\n.empty-state {\n  text-align: center;\n  padding: 60px 20px;\n  color: var(--text-secondary);\n}\n\n.empty-state-icon {\n  font-size: 64px;\n  margin-bottom: 20px;\n  opacity: 0.5;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .contacts-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .toolbar-top,\n  .toolbar-bottom {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .search-box {\n    width: 100%;\n  }\n\n  .contact-list-item {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .contact-list-info {\n    grid-template-columns: 1fr;\n  }\n\n  .form-row {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
